import { render, staticRenderFns } from "./MaterialsCatalog.vue?vue&type=template&id=1b258c14&scoped=true"
import script from "./MaterialsCatalog.vue?vue&type=script&lang=js"
export * from "./MaterialsCatalog.vue?vue&type=script&lang=js"
import style0 from "./MaterialsCatalog.vue?vue&type=style&index=0&id=1b258c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b258c14",
  null
  
)

export default component.exports